import { usePerformSignoutOperation } from 'components/accessControl/hooks/usePerformSignoutOperation';

export const useOnClickLogout = () => {
  const { logout } = usePerformSignoutOperation();
  return logout;
};
